/* eslint-disable @typescript-eslint/no-explicit-any */

import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import store from '@/store'
import { FiltersServices } from '@/services/modules/filters.service'

@Module
export default class FiltersStore extends VuexModule {
    reportCategoriesFilter: object[] = []
    reporDatasourcesFilter: object[] = []
    reporChartTypesFilter: object[] = []
    usersFilter: object[] = []

    @Mutation
    updateReportCategoriesFilter (newObject: object[]) {
        this.reportCategoriesFilter = newObject
    }

    @Mutation
    updateDatasourcesFilter (newObject: object[]) {
        this.reporDatasourcesFilter = newObject
    }

    @Mutation
    updateChartTypesFilter (newObject: object[]) {
        this.reporChartTypesFilter = newObject
    }

    @Mutation
    updateUsersFilter (newObject: object[]) {
        this.usersFilter = newObject
    }

    @Action
    getReportCategoriesFilter () {
        return new Promise((resolve) => {
            FiltersServices.getReportCategoriesFilter()
                .then(resp => {
                    store.commit('updateReportCategoriesFilter', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReporDatasourcesFilter () {
        return new Promise((resolve) => {
            FiltersServices.getReporDatasourcesFilter()
                .then(resp => {
                    store.commit('updateDatasourcesFilter', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReporChartTypesFilter () {
        return new Promise((resolve) => {
            FiltersServices.getReporChartTypesFilter()
                .then(resp => {
                    store.commit('updateChartTypesFilter', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getUsersFilter () {
        return new Promise((resolve) => {
            FiltersServices.getUsersFilter()
                .then(resp => {
                    store.commit('updateUsersFilter', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
